<template>
  <blank-view>
    <div slot="action" >
      <div style="display: flex; align-items: center; justify-content: space-between">
        <div>
          <a-button v-acl="'page_ops_record_report_export'" style="margin-right: 8px" @click="exportWorkRecord">{{
              $t('page_ops_work_record_export')
            }}</a-button>
        </div>
        <div>
          <div class="flex status-choose">
            <div class="flex status-choose state-filter">
              {{ $t('page_ops_work_record_filter')+':' }}
              <div v-for="status in dictList" :key="status.dictKey">
                <a-tag
                    v-if="inSearchStatus(status.dictKey)"
                    :color="status.remark"
                    @click="inputStatus(status.dictKey)"
                >
                  {{ status.dictValue }}
                </a-tag>
                <a-tag
                    v-else
                    style="background: #fff; borderstyle: dashed"
                    @click="inputStatus(status.dictKey)"
                >
                  {{ $t(status.dictValue) }}
                </a-tag>
              </div>
            </div>
            <a-button style="margin-right: 8px" @click="toggleSearch" class="heightSearch">
              {{ $t('page_my_document_advanced') }}
            </a-button>
            <a-input-search
                :placeholder="$t('common_please_input') + $t('keyword')"
                :enterButton="$t('search')"
                style="width: 300px"
                v-model="filter.keywords"
                allowClear
                :loading="exportLoading"
                @search="()=>{filter.isAdvance = false;keywordSearch();getStatistics(false);}"
            />
          </div>
        </div>
      </div>
      <div class="status">
        <div v-for="i in Object.keys(statusMap)" :key="i" class="status-item">
          <div class="label">{{statusMap[i].label}}</div>
          <div class="value" :style="{'color': statusMap[i].color}">{{statusMap[i].value}}</div>
        </div>
      </div>
    </div>
    <div id="content" style="height: 100%;display: flex; flex-direction: column;" :style="{ justifyContent: dataSource.length>0 ? '': 'center' }">
      <template v-if="dataSource.length>0">
        <div>
          <ml-table
              style="width: 100%;"
              :columns="columns"
              :dataSource="dataSource"
              :canChangeColWidth="false"
              rowKey="id"
              :loading="exportLoading"
              :scroll="{ x: 1500, y: scrollY }"
          >
            <template slot="action" slot-scope="text, record">
            <span v-acl="'page_ops_record_report_edit'">
              <a @click.stop="edit(record)">{{ $t('edit') }}</a>
            </span>
            </template>
          </ml-table>
        </div>
        <a-pagination
            size="small"
            style="text-align: right; padding: 8px 0;"
            show-size-changer
            :show-total="(total) => `${showTotal(total)}`"
            :current="pagination.current"
            :pageSize="pagination.pageSize"
            :total="pagination.total"
            @showSizeChange="onShowSizeChange"
            @change="handleTableChange"
        />
      </template>
      <template v-else>
        <a-empty :image-style="{height: '150px'}" />
      </template>
    </div>
    <gallery
        v-if="galleryVisible"
        :visible="galleryVisible"
        :imgs="previewImgs"
        :index="imgIndex"
        @cancel="onGalleryCancel"
    />
    <advance-search
        :sub-title="$t('page_ops_record_report')"
        :visible="advanceVisible"
        :formData="filter.advance"
        :loading="exportLoading"
        @close="closeToggleSearch"
        @advanceSearch="startToggleSearch"
        @reset="resetSearch"
    ></advance-search>

    <distribute-model
        ref="distribute"
        :visible="distributeModelVisible"
        @cancel="closeDistributeModel"
    >
    </distribute-model>
    <handle-model ref="handle" :visible="handleModelVisible" @cancel="closeHandleModel">
    </handle-model>
    <audit-model ref="audit" :visible="auditModelVisible" @cancel="closeAuditModel"> </audit-model>
    <EditModel
      v-if="newModelVisible"
      ref="new"
      :visible="newModelVisible"
      @ok="okNewModel"
      @cancel="closeNewModel"
      :isEdit="isEdit"
      :edit-data="changeWorkRecord"
    />
  </blank-view>
</template>

<script>
import { Empty } from 'ant-design-vue'
import dayjs from 'dayjs'
import { mapGetters, mapActions } from 'vuex'
import { WorkRecordReportServiceProxy,WorkRecordStatisticsServiceProxy} from '@/service-proxies/app-v2/work-record.service-proxies'
const wrsrcp = new WorkRecordReportServiceProxy()
const workRecordStatisticsServiceProxy = new WorkRecordStatisticsServiceProxy()
import { DictBizServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
const dictServiceProxy = new DictBizServiceProxy()

import AdvanceSearch from './components/advanceSearch'
import DistributeModel from '../list/components/distribute.vue'
import AuditModel from '../list/components/audit.vue'
import HandleModel from '../list/components/handle.vue'
import EditModel from './components/edit'
import {exportRecordReport} from "../../../../api/api";

export default {
  components: {
    AdvanceSearch,
    DistributeModel,
    AuditModel,
    HandleModel,
    EditModel
  },
  data() {
    return {
      selectedRow: {}, // 编辑数据
      chooseCustomerId: '',
      isEdit: false, // 是否是编辑
      changeWorkRecord: {
        workRecordId: undefined,
        customerId: undefined,
        currentMachine: undefined,
        customerAddress: undefined
      },
      advanceVisible: false,
      distributeModelVisible: false,
      handleModelVisible: false,
      auditModelVisible: false,
      newModelVisible: false,
      selectedRowKeys: [],
      filter: {
        keywords: '',
        status: [],
        advance: {
          areaId: undefined,
          areaName: '',
          regionName: '',
          submitUserId: undefined,
          request: '',
          contactUserName: '',
          deviceTypeIds: [],
          time: [],
          startTime: '',
          endTime: '',
          questionDescription: '',
          customerId: undefined,
          provinceId: undefined,
          provinceName: '',
          cityId: undefined,
          cityName: '',
          isInvolvedMachine: '',
          workStationId: undefined,
          workstationName: undefined,
          claimUser: undefined
        },
        isAdvance: false,
        defaultAllStatus: []
      },
      dataSource: [],
      dictList: [],
      pagination: {
        total: 0,
        pageSize: 20,
        current: 1
      },
      scrollY: 0,
      exportLoading: false,
      galleryVisible: false,
      previewImgs: [],
      imgIndex: 0,
      statusMap: {},
      colorMap: {
        'blue': {color: '#1890ff', backgroundColor: '#e6f7ff', code: 'distribute'},
        'orange': {color: '#fa8c16', backgroundColor: '#fff7e6', code: 'pending'},
        'green': {color: '#52c41a', backgroundColor: '#f6ffed', code: 'audit'},
        'purple':{color: '#722ed1', backgroundColor: '#f9f0ff', code: 'complete'}
      },
    }
  },
  computed: {
    ...mapGetters(['makinoJumpValue']),
    columns() {
      return [
        { title: '操作',
          width: this.handleWidth(55),
          dataIndex: 'action',
          key: 'action',
          fixed: 'left',
          scopedSlots: { customRender: 'action' }
        },
        {
          title: this.$t('page_ops_work_record_document_number'),
          dataIndex: 'code',
          key: 'code',
          ellipsis: true,
          width: this.handleWidth()
        },
        {
          title: this.$t('page_ops_work_record_customer_name'),
          dataIndex: 'customerName',
          ellipsis: true,
          key: 'customerName',
          width: this.handleWidth()
        },
        {
          title: this.$t('page_ops_customer_region'),
          dataIndex: 'areaName',
          ellipsis: true,
          key: 'areaName',
          width: this.handleWidth(80)
        },
        {
          title: this.$t('province'),
          dataIndex: 'provinceName',
          ellipsis: true,
          key: 'provinceName',
          width: this.handleWidth(80)
        },
        {
          title: this.$t('city'),
          dataIndex: 'cityName',
          ellipsis: true,
          key: 'cityName',
          width: this.handleWidth(80)
        },
        {
          title: this.$t('page_material_customer_address'),
          dataIndex: 'address',
          ellipsis: true,
          key: 'address',
          width: this.handleWidth(300)
        },
        {
          title: this.$t('page_business_device_type'),
          dataIndex: 'deviceTypeName',
          ellipsis: true,
          key: 'deviceTypeName',
          width: this.handleWidth(80)
        },
        {
          title: this.$t('page_plan_maintenance_equipment_name_jian'),
          dataIndex: 'workstationName',
          ellipsis: true,
          key: 'workstationName',
          width: this.handleWidth()
        },
        {
          title: this.$t('page_ops_machine_machine_serialNo'),
          dataIndex: 'workstationSerialNo',
          ellipsis: true,
          key: 'workstationSerialNo',
          width: this.handleWidth()
        },
        {
          title: this.$t('page_ops_work_record_submit_person'),
          dataIndex: 'submitUserName',
          ellipsis: true,
          key: 'submitUserName',
          width: this.handleWidth()
        },
        {
          title: this.$t('page_ops_work_record_contact_person'),
          dataIndex: 'contactUserName',
          ellipsis: true,
          key: 'contactUserName',
          width: this.handleWidth()
        },
        {
          title: this.$t('page_ops_work_record_contact_information'),
          dataIndex: 'contactInfo',
          ellipsis: true,
          key: 'contactInfo',
          width: this.handleWidth(120)
        },
        {
          title: this.$t('page_ops_work_record_resolution_progress'),
          dataIndex: 'processProgress',
          ellipsis: true,
          key: 'processProgress',
          width: this.handleWidth(80),
          customRender: (value, row, index)=>{
            let tagValue = this.getStateValue(value)
            return {
              children: <a-tag color={tagValue.remark}>{tagValue.dictValue} </a-tag>,
            }
          }
        },
        {
          title: this.$t('page_ops_work_record_customer_request'),
          dataIndex: 'questionDescription',
          ellipsis: true,
          key: 'questionDescription',
          width: this.handleWidth()
        },
        {
          title:  this.$t('page_work_record_handle_detail'),
          dataIndex: 'processedDesc',
          ellipsis: true,
          key: 'processedDesc',
          width: this.handleWidth()
        },
        {
          title: this.$t('page_work_record_request_image'),
          dataIndex: 'attachList',
          ellipsis: false,
          key: 'attachList',
          width: 270,
          customRender: (value, row, index)=>{
            if(value && value.length>0) {
              return value.map( (v,i) => <img class="img" src={v} onClick={()=>{this.previewImgs= value; this.imgIndex=i;this.galleryVisible= true}} /> );
            }
          }
        },
        {
          title: this.$t('page_work_record_handle_image'),
          dataIndex: 'processedAttachList',
          ellipsis: false,
          key: 'processedAttachList',
          width: 270,
          customRender: (value, row, index)=>{
            if(value && value.length>0) {
              return value.map( (v,i) => <img class="img" src={v} onClick={()=>{this.previewImgs= value; this.imgIndex=i;this.galleryVisible= true}} /> );
            }
          }
        },
        {
          title: this.$t('page_work_record_engineer_name'),
          dataIndex: 'claimUserName',
          ellipsis: true,
          key: 'claimUserName',
          width: this.handleWidth()
        },
        {
          title: this.$t('page_work_record_work_instructions'),
          dataIndex: 'distributeDesc',
          ellipsis: true,
          key: 'distributeDesc',
          width: this.handleWidth()
        },
        {
          title: this.$t('page_ops_work_record_job_classification'),
          dataIndex: 'jobTypeName',
          ellipsis: true,
          key: 'jobTypeName',
          width: this.handleWidth()
        },
        {
          title: this.$t('page_ops_work_record_industry_classification'),
          dataIndex: 'industryTypeName',
          ellipsis: true,
          key: 'industryTypeName',
          width: this.handleWidth()
        },
        {
          title: this.$t('page_work_record_handle_start_time'),
          dataIndex: 'handleStartTime',
          ellipsis: true,
          key: 'handleStartTime',
          width: this.handleWidth(),
          customRender: (value, row, index)=>{
            if(value) {
              return <div>{dayjs(value).format('YYYY-MM-DD HH:mm:ss')}</div>
            } else {
              return  ''
            }
          }
        },
        {
          title: this.$t('page_work_record_handle_end_time'),
          dataIndex: 'handleEndTime',
          ellipsis: true,
          key: 'handleEndTime',
          width: this.handleWidth(),
          customRender: (value, row, index)=>{
            if(value) {
              return <div>{dayjs(value).format('YYYY-MM-DD HH:mm:ss')}</div>
            } else {
              return  ''
            }
          }
        },
        {
          title: this.$t('page_work_record_total_time'),
          dataIndex: 'handleTimeConsuming',
          ellipsis: true,
          key: 'handleTimeConsuming',
          width: this.handleWidth()
        },
        {
          title: this.$t('page_work_record_create_time'),
          dataIndex: 'createRequestTime',
          ellipsis: true,
          key: 'createRequestTime',
          width: this.handleWidth(),
          customRender: (value, row, index)=>{
            if(value) {
              return <div>{dayjs(value).format('YYYY-MM-DD HH:mm:ss')}</div>
            } else {
              return  ''
            }
          }
        },
        {
          title: this.$t('page_work_record_request_user'),
          dataIndex: 'createRequestUserName',
          ellipsis: true,
          key: 'createRequestUserName',
          width: this.handleWidth()
        },
        {
          title: this.$t('page_work_record_distribute_time'),
          dataIndex: 'distributeTime',
          ellipsis: true,
          key: 'distributeTime',
          width: this.handleWidth(),
          customRender: (value, row, index)=>{
            if(value) {
              return <div>{dayjs(value).format('YYYY-MM-DD HH:mm:ss')}</div>
            } else {
              return  ''
            }
          }
        },
        {
          title: this.$t('page_work_record_distribute_user'),
          dataIndex: 'distributeUserName',
          ellipsis: true,
          key: 'distributeUserName',
          width: this.handleWidth()
        },
        {
          title: this.$t('page_work_record_process_start_time'),
          dataIndex: 'processingTime',
          ellipsis: true,
          key: 'processingTime',
          width: this.handleWidth(),
          customRender: (value, row, index)=>{
            if(value) {
              return <div>{dayjs(value).format('YYYY-MM-DD HH:mm:ss')}</div>
            } else {
              return  ''
            }
          }
        },
        {
          title: this.$t('page_work_record_process_end_time'),
          dataIndex: 'processedTime',
          ellipsis: true,
          key: 'processedTime',
          width: this.handleWidth(),
          customRender: (value, row, index)=>{
            if(value) {
              return <div>{dayjs(value).format('YYYY-MM-DD HH:mm:ss')}</div>
            } else {
              return  ''
            }
          }
        },
        {
          title: this.$t('page_work_record_process_user'),
          dataIndex: 'processingUserName',
          ellipsis: true,
          key: 'processingUserName',
          width: this.handleWidth()
        },
        {
          title: this.$t('page_work_record_audit_time'),
          dataIndex: 'auditedTime',
          ellipsis: true,
          key: 'auditedTime',
          width: this.handleWidth(),
          customRender: (value, row, index)=>{
            if(value) {
              return <div>{dayjs(value).format('YYYY-MM-DD HH:mm:ss')}</div>
            } else {
              return  ''
            }
          }
        },
        {
          title: this.$t('page_work_record_audit_user'),
          dataIndex: 'auditedUserName',
          ellipsis: true,
          key: 'auditedUserName',
          width: this.handleWidth()
        },
        {
          title: this.$t('page_work_record_audit_desc'),
          dataIndex: 'auditedDesc',
          ellipsis: true,
          key: 'auditedDesc',
          width: this.handleWidth()
        },
        {
          title: this.$t('page_work_record_wechat'),
          dataIndex: 'wxAccount',
          ellipsis: true,
          key: 'wxAccount',
          width: this.handleWidth()
        },
        {
          title: this.$t('page_work_record_email'),
          dataIndex: 'email',
          ellipsis: true,
          key: 'email',
          width: this.handleWidth()
        },
        {
          title: this.$t('page_ops_work_record_component_request'),
          dataIndex: 'componentRequest',
          ellipsis: true,
          key: 'componentRequest',
          width: this.handleWidth()
        },
        {
          title: this.$t('page_ops_work_record_component_request_detail'),
          dataIndex: 'componentDesc',
          ellipsis: true,
          key: 'componentDesc',
          width: this.handleWidth()
        },
      ]
    }
  },
  beforeCreate() {
    this.simpleImage = Empty.PRESENTED_IMAGE_SIMPLE
  },
  async created() {
    await this.getStateDict()
    this.getStatistics();
    this.keywordSearch();
  },
  methods: {
    ...mapActions({
      saveMakinoJump: 'app/saveMakinoJump'
    }),
    getParams() {
      const params = {
        processProgress: this.getFilterStatus(),
        idList: this.selectedRowKeys,
        keyValue: this.filter.keywords,
        questionDesc: this.filter.advance.request,
        areaName: this.filter.advance.areaName,
        startTime: this.filter.advance.startTime,
        endTime: this.filter.advance.endTime,
        submitUserId: this.filter.advance.submitUserId,
        deviceTypeIds: this.filter.advance.deviceTypeIds,
        contactUserName: this.filter.advance.contactUserName,
        isAdvance: this.filter.isAdvance,
        customerId: this.filter.advance.customerId,
        provinceName: this.filter.advance.provinceName,
        cityName: this.filter.advance.cityName,
        claimUser: this.filter.advance.claimUser,
        isInvolvedMachine: this.filter.advance.isInvolvedMachine,
        workstationId: this.filter.advance.workStationId,
        workstationName: this.filter.advance.workstationName
      }
      return params;
    },
    exportWorkRecord() {
      const params = this.getParams();
      exportRecordReport(params).then(res=>{
        // 创建隐藏的可下载链接
        var a = document.createElement('a')
        a.download = `${this.$t('page_ops_record_report')}.xlsx`
        a.style.display = 'none'
        // 字符内容转变成blob地址
        let url = URL.createObjectURL(res)
        a.href = url
        // 触发点击
        document.body.appendChild(a)
        a.click()
        // 然后移除
        URL.revokeObjectURL(url)
        document.body.removeChild(a)
      })
    },
    handleWidth(width) {
      if(this.dataSource.length) {
        return width || 160
      } else {
        return  null
      }
    },
    showTotal(total) {
      return this.$t('Total…items').replace('{0}', total)
    },
    handleTableChange(current) {
      this.pagination.current = current
      this.advanceSearch()
    },
    resetSearch() {
      this.filter.advance = {
        areaId: undefined,
        areaName: '',
        regionName: '',
        submitUserId: undefined,
        request: '',
        contactUserName: '',
        deviceTypeIds: [],
        time: [],
        startTime: '',
        endTime: '',
        questionDescription: '',
        customerId: undefined,
        provinceId: undefined,
        provinceName: '',
        cityId: undefined,
        cityName: '',
        claimUser: undefined,
        isInvolvedMachine: '',
        workStationId: undefined,
        workstationName: undefined,
    }
    },
    distribute(record) {
      this.$refs['distribute'].initData(record)
      this.distributeModelVisible = true
    },
    handle(record) {
      this.$refs['handle'].initData(record)
      this.handleModelVisible = true
    },
    audit(record) {
      this.$refs['audit'].initData(record)
      this.auditModelVisible = true
    },
    edit(record) {
      wrsrcp.getWorkRecordReportEditDetail(record.workRecordId).then((res) => {
        const { workstationId, customerId,customerAddress } = res;
        let address = ''
        if(customerAddress.provinceName){
          if(customerAddress.provinceName === customerAddress.cityName){
            address= `${customerAddress.provinceName}${customerAddress.address}`
          }
          address = `${customerAddress.provinceName}${customerAddress.cityName}${customerAddress.address}`
        }
        this.changeWorkRecord = {
          workRecordId: record.workRecordId,
          customerId: customerId,
          currentMachine: workstationId || '',
          customerAddress: address
        }
      });

      this.isEdit = true
      this.newModelVisible = true
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    onShowSizeChange(current, pageSize) {
      this.pagination.pageSize = pageSize;
      this.advanceSearch();
    },
    toggleSearch() {
      this.advanceVisible = !this.advanceVisible
    },
    closeToggleSearch() {
      this.advanceVisible = false
    },
    startToggleSearch(value) {

      this.filter.keywords = ''
      this.filter.advance = value
      this.pagination.current = 1;
      this.filter.isAdvance = true;
      this.advanceSearch()
    },
    handleAdd() {
      this.isEdit = false
      this.newModelVisible = true
    },
    keywordSearch() {
      this.exportLoading = true;
      const params = this.getParams();
      const {current, pageSize:size} = this.pagination;
      wrsrcp.page(current, size, params).then(res=>{
        if(res.records && res.records.length>0) {
          this.dataSource = res.records;
          this.pagination.total = res.total;
        } else {
          this.dataSource = [];
          this.pagination.total = 0;
        }
        this.exportLoading = false;
        this.setScroll(res);
      }).catch(_=>{
        this.exportLoading = false;
      })
    },
    getStatistics(isAdvance) {
      const params = this.getParams();
      workRecordStatisticsServiceProxy.getWorkRecordStatistics(params).then(res=>{
        Object.keys(res).map(v=>{
          this.statusMap[v].value = res[v];
        });
      })
    },
    advanceSearch() {
      this.getStatistics();
      this.keywordSearch();
    },
    setScroll(data) {
      const dev = document.getElementById('content')
      if (dev) {
        const height = dev.clientHeight -80
        this.scrollY = height;
      }
    },
    getFilterStatus() {
      if (
          (this.makinoJumpValue != '' || this.makinoJumpValue != undefined) &&
          this.makinoJumpValue.length > 0
      ) {
        this.filter.status = [this.makinoJumpValue + '']
        this.saveMakinoJump('')
      }

      return this.filter.status.length > 0 ? this.filter.status : this.filter.defaultAllStatus
    },
    async getStateDict() {
      let res = await dictServiceProxy.dictionary('work_record_status');
      this.dictList = res.data
      let statusMap = {};
      statusMap['all'] = {color: '#333333', value: '--', key: '-1',label: '全部' }
      res.data.map(v=>{
        const {code} = this.colorMap[v.remark];
        statusMap[code] = {color: this.colorMap[v.remark].color, value: '--', key: v.dictKey, label: v.dictValue};
      });
      this.statusMap = statusMap;
      this.filter.defaultAllStatus = this.dictList.map((x) => x.dictKey)
      this.filter.status = this.filter.defaultAllStatus.slice(0,-1)
    },

    getStateValue(value) {
      let target = this.dictList.find((res) => res.dictValue == value)
      return target || { remark: '', dictValue: value }
    },
    inSearchStatus(value) {
      return this.filter.status.indexOf(value) > -1
    },
    inputStatus(value) {
      const newTags = [...this.filter.status]
      const status = this.filter.status.find((res) => res == value)
      if (!status) {
        this.filter.status.push(value)
      } else {
        this.filter.status = newTags.filter((res) => res != value)
      }
      this.initPagination()
      this.getStatistics();
    },
    closeDistributeModel(isSuccess) {
      if (isSuccess) {
        this.initPagination()
        const id = this.selectedRow.id;
        this.selectedRow.id = '';
        setTimeout(() => {
          this.selectedRow.id = id;
        }, 100);
      }
      this.distributeModelVisible = false
    },
    closeAuditModel(isSuccess) {
      if (isSuccess) {
        this.initPagination()
      }
      this.auditModelVisible = false
    },
    closeHandleModel(isSuccess) {
      if (isSuccess) {
        this.initPagination()
        const id = this.selectedRow.id;
        this.selectedRow.id = '';
        setTimeout(() => {
          this.selectedRow.id = id;
        }, 100);
      }
      this.handleModelVisible = false
    },
    okNewModel(){
      this.initPagination()
      const id = this.selectedRow.id;
      this.selectedRow.id = '';
      setTimeout(() => {
        this.selectedRow.id = id;
      }, 100);
      this.newModelVisible = false
    },
    closeNewModel() {
      this.newModelVisible = false
    },
    clickRow(row) {
      this.selectedRow = row
      this.selectedRowId = row.id
      this.selectedRowKeys = [row.id]
    },
    initPagination() {
      this.pagination.current = 1
      this.pagination.pageSize = 20;
      this.keywordSearch();
    },
    onGalleryCancel() {
      this.galleryVisible = false;
    }
  }
}
</script>

<style lang="less" scoped>
.exception {
  width: 100%;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.custom-list {
  width: 700px;
  position: relative;
}
.custom-detail {
  width: calc(100% - 700px);
  border-left: 1px solid #d7d7d7;
  height: 100%;
  overflow: auto;
}

.status-choose {
  align-items: center;
  @media screen and (max-width: 1505px) {
    min-width: 340px;
  }
}
.state-filter {
  background-color: white;
  padding: 5px;
  margin-right: 9px;
  border: 1px solid #d9d9d9;
}
.img{
  width: 80px;
  height: 80px;
  margin-right: 4px;
  &:nth-child(n+4){
    margin-top: 4px;
  }
  &:nth-child(3n) {
    margin-right: 0;
  }
}
.status{
  display: flex;
  background-color: #ffffff;
  padding: 16px 0;
  margin-top: 8px;
  .status-item{
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    &:not(:last-child) {
      border-right: 1px solid #e8e8e8;
    }
    .label{
      margin-right: 8px;
    }
    .value {
      font-size: 28px;
    }
  }
}
</style>
